import React, { useEffect, useState } from 'react';
import {
      doc,
      updateDoc,
      increment,
      collection,
      addDoc,
      query,
      where,
      getDocs
} from 'firebase/firestore';
import { db } from '../firebase/config';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import { toastedError, toastedInfo, toastedSuccess } from '../config/toast';

const LikeButton = ({ problemId, likes = 0 }) => {
      const [loading, setLoading] = useState(false);
      const [liked, setLiked] = useState(false);

      const user = JSON.parse(localStorage.getItem('user'));

      // 🔍 Check if already liked
      useEffect(() => {
            const checkLike = async () => {
                  if (!user?.uid) return;

                  const q = query(
                        collection(db, 'likes'),
                        where('problemId', '==', problemId),
                        where('userId', '==', user.uid)
                  );

                  const snap = await getDocs(q);

                  if (!snap.empty) {
                        setLiked(true);
                  }
            };

            checkLike();
      }, [problemId, user]);

      // ❤️ Handle Like
      const handleLike = async () => {
            if (loading) return;

            if (!user?.uid) {
                  toastedError('Login required');
                  return;
            }

            if (liked) {
                  toastedInfo('Already liked 👍');
                  return;
            }

            try {
                  setLoading(true);

                  // Save like record
                  await addDoc(collection(db, 'likes'), {
                        problemId,
                        userId: user.uid,
                        createdAt: new Date(),
                  });

                  // Update count
                  const ref = doc(db, 'problems', problemId);

                  await updateDoc(ref, {
                        likes: increment(1),
                  });

                  setLiked(true);
                  toastedSuccess('Item Liked')
            } catch (error) {
                  console.error('Like error:', error);
            } finally {
                  setLoading(false);
            }
      };

      return (
            <button
                  className={`action-btn like-btn ${liked ? 'liked' : ''}`}
                  onClick={handleLike}
                  disabled={loading}
            >
                  {liked ? <Favorite /> : <FavoriteBorder />} <span>{likes}</span>
            </button>
      );
};

export default LikeButton;